module.exports = __webpack_public_path__ + "img/login-bg-b81814b6acef0dff13724dd91ba7182b.svg";